<div class="dynamic-field-container" [class.selected]="config?.selected">
  <div
    class="dynamic-field form-input text-align"
    [hidden]="!config?.isFormBuilder && config?.options?.hidden"
  >
    <ups-dynamic-helper-label
      [config]="config"
      [dynamicService]="dynamicService"
    ></ups-dynamic-helper-label>
    <div class="job-search-container" style="position: relative">
      <kendo-dropdownlist
        #dropdown
        class="k-no-dropdown w-100"
        [attr.name]="config.formControlName"
        [value]="viewItem"
        [class.ng-invalid]="viewStatus.invalid"
        [class.ng-valid]="viewStatus.valid"
        [class.ng-touched]="viewStatus.touched"
        [disabled]="viewDisabled"
        [valuePrimitive]="false"
        [textField]="'name'"
        [valueField]="'po'"
        [defaultItem]="{ name: config?.placeholder }"
        [filterable]="true"
        (valueChange)="pickFromView($event)"
        (blur)="blurFromView()"
        search-ex
        [seSearchColumns]="['po', 'description']"
        (seFilterChangeEx)="filterChangeItem($event)"
        [seDebounceFilterChange]="150"
        [seUseCustomLocalFilter]="true"
        [seMinSearchLength]="0"
        [loading]="isLoading"
        [tabindex]="tabindex"
      >
        <ng-template kendoDropDownListItemTemplate let-dataItem>
          <span
            class="job-name link-style"
            [hidden]="dataItem?.name === config?.placeholder"
          >
            {{ dataItem?.name }}
          </span>
        </ng-template>
        <ng-template kendoDropDownListValueTemplate let-dataItem>
          <span class="job-name" kendoTooltip [title]="dataItem?.name">
            {{ dataItem?.name }}
          </span>
        </ng-template>
      </kendo-dropdownlist>
    </div>
    <ups-dynamic-search-error [show]="searchError"></ups-dynamic-search-error>
    @if (config?.isFormBuilder) {
      <div
        class="form-builder-mask"
        [class.hidden]="config?.options?.hidden"
      ></div>
    }
  </div>
  @if (config?.isFormBuilder) {
    <div class="form-builder-options">
      <i class="fas fa-times ms-3 cursor-pointer c-red" (click)="delete()"></i>
      <!-- <i class="fas fa-bars ms-3 cursor-grab"></i> -->
    </div>
  }
</div>
